// extracted by mini-css-extract-plugin
export var appBadgeContainer = "footer-module--app-badge-container--QM4RW";
export var footer = "footer-module--footer--Z1xkR";
export var info = "footer-module--info--6bQYw";